import React from 'react'
import { formatDuration, formatTimeRange } from '../../utils/scheduleUtils'

/**
 * The clashes in the current plan, spelled out.
 *
 * The timeline already shows overlaps geometrically, but "which two, and by
 * how much" is the thing you actually decide on, and it should not require
 * measuring blocks by eye.
 */
const ConflictList = ({ conflicts }) => {
  if (conflicts.length === 0) return null

  const hard = conflicts.filter(conflict => conflict.severity === 'hard')
  const soft = conflicts.filter(conflict => conflict.severity === 'soft')

  return (
    <div className={`rounded-xl border p-4 ${
      hard.length > 0
        ? 'bg-red-500/10 border-red-500/40'
        : 'bg-amber-500/10 border-amber-500/40'
    }`}>
      <h3 className={`font-semibold mb-3 ${hard.length > 0 ? 'text-red-200' : 'text-amber-200'}`}>
        ⚠ {conflicts.length} {conflicts.length === 1 ? 'clash' : 'clashes'} in your plan
      </h3>

      <div className="space-y-2">
        {[...hard, ...soft].map(conflict => (
          <div
            key={conflict.id}
            className="text-sm bg-black/20 rounded-lg px-3 py-2"
          >
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-medium text-white">{conflict.a.name}</span>
              <span className="text-gray-400">vs</span>
              <span className="font-medium text-white">{conflict.b.name}</span>
              {conflict.severity === 'soft' && (
                <span className="text-xs px-1.5 py-0.5 rounded-full bg-amber-400/20 text-amber-100">
                  one is a maybe
                </span>
              )}
            </div>
            <div className="text-xs text-gray-300 mt-1">
              Overlap {formatDuration(conflict.overlapMinutes)} ·{' '}
              {formatTimeRange(conflict.a.startTime, conflict.a.endTime)} /{' '}
              {formatTimeRange(conflict.b.startTime, conflict.b.endTime)}
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-3">
        Tap ★ on a set to downgrade it to a maybe, or tap the set to drop it.
      </p>
    </div>
  )
}

export default ConflictList
